// extracted by mini-css-extract-plugin
export default {"heroWrapper":"heroMsg_heroWrapper__mo+sv"};